import { useRef } from 'react';
import debounce from 'lodash/debounce';

export function useDebounce(func, wait, options = {}) {
    return useRef(debounce(func, wait, options)).current;
}
